import { render, staticRenderFns } from "./TextInputAdvancedProps.vue?vue&type=template&id=2b518090"
import script from "./TextInputAdvancedProps.vue?vue&type=script&lang=js"
export * from "./TextInputAdvancedProps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports